jQuery(document).ready(function($) {

  if ( typeof acf !== 'undefined' ) {

    // Set color picker defaults to color palette
    // https://www.advancedcustomfields.com/resources/javascript-api/#filters-color_picker_args
    acf.add_filter('color_picker_args', function( args, $field ){

      // var field_info = $field[0]['dataset'];
      // console.log('Field Key: '+field_info['key']);
      // console.log('Field Name: '+field_info['name']);
      // console.log('Field Type: '+field_info['type']);

      // do something to args
      args.palettes = ['#253876', '#0e6632', '#de9d32', '#e17262', '#f1f0ef', '#000000', '#ffffff','#f2f0e8', '#ffd549', '#eb6b55', '#9d99ff', '#43c264' ];

      // return
      return args;

    });

  }  

});